<template>
  <div
    v-if="showRichInbox"
    :class="['rich-inbox-button-wrapper', { 'rich-inbox-button-wrapper-animate': shouldAnimate }]"
  >
    <LcButton
      :aria-label="$t('richinbox.button.arialabel')"
      size="small"
      type="button"
      variant="raised"
      class="rich-inbox-button"
      no-padding
      @click="isBottomSheetOpen = true"
    >
      <img
        alt=""
        :class="{ 'bell-shake': !hasAnimated }"
        :height="ICON_SIZE"
        :src="bellIcon"
        :width="ICON_SIZE"
        aria-hidden="true"
      />
    </LcButton>

    <LcBottomSheet v-model="isBottomSheetOpen" :snap-heights="['20rem', '95dvh']">
      <template #title>
        <h2 class="headline-h5-headline">{{ $t('richinbox.headline') }}</h2>
      </template>

      <RichInboxMessageList />
    </LcBottomSheet>
  </div>
</template>

<script lang="ts" setup>
import { LcBottomSheet } from '@lottocom/frontend-components'
import { useTimeoutFn } from '@vueuse/core'

import bellStatic from '../assets/img/bell-static.svg'

const ICON_SIZE = 24
const ANIMATION_DURATION = 2000

const isRichInboxEnabled = useIsFeatureFlagEnabled('richInbox')
const { isLoggedIn } = useAuth()

const isBottomSheetOpen = ref(false)
const hasAnimated = useState('richInboxHasAnimated', () => false)
const bellIcon = bellStatic

const showRichInbox = computed(() => isRichInboxEnabled && isLoggedIn.value)
const shouldAnimate = computed(() => !hasAnimated.value)

useTimeoutFn(
  () => {
    hasAnimated.value = true
  },
  ANIMATION_DURATION,
  { immediate: !hasAnimated.value },
)
</script>

<style lang="scss" scoped>
.rich-inbox-button-wrapper {
  width: 2rem;
  line-height: 1;

  .rich-inbox-button {
    padding: token('size/space/gap/050');
    border: none;
    transition: none;
  }

  &-animate {
    animation: fade-in 200ms ease-out both;
  }
}

@keyframes fade-in {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes bell-shake {
  0% {
    transform: rotate(0deg);
  }

  10% {
    transform: rotate(-14deg);
  }

  20% {
    transform: rotate(12deg);
  }

  30% {
    transform: rotate(-10deg);
  }

  40% {
    transform: rotate(8deg);
  }

  50% {
    transform: rotate(-6deg);
  }

  60% {
    transform: rotate(4deg);
  }

  70% {
    transform: rotate(-2deg);
  }

  80%,
  100% {
    transform: rotate(0deg);
  }
}

.bell-shake {
  transform-origin: center top;
  animation: bell-shake 1000ms ease-in-out 800ms 1 both;
}

@media (prefers-reduced-motion: reduce) {
  .rich-inbox-button-wrapper-animate,
  .bell-shake {
    animation: none;
  }
}
</style>
